import React from "react";
import Preloader from "../helper/Preloader";

import Breadcrumb from "../components/Breadcrumb";
import ShopSection from "../components/ShopSection";
import Shipping from "../components/Shipping";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";

const ShopPage = () => {

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400"/>

      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb */}
      <Breadcrumb title={"Shop"} />

      {/* ShopSection */}
      <ShopSection />

      {/* Shipping */}
      <Shipping />



    </>
  );
};

export default ShopPage;
